
export const REACT_APP_GEOTOLK_API= "https://geotolk-api.norconsultgeoapplications.com"
